import { Loader2 } from 'lucide-react';

const FollowerLoadingState = () => {
  return (
    <div className='flex h-full flex-col p-5'>
      {/* Fixed Filter and Selection Bar */}
      <div className='flex-shrink-0 space-y-4 rounded-lg bg-muted/50 p-4'>
        {/* Top Row: Filters - Placeholder */}
        <div className='flex flex-wrap items-center gap-4'>
          <div className='h-10 w-24 animate-pulse rounded-md bg-muted'></div>
          <div className='h-10 w-48 animate-pulse rounded-md bg-muted'></div>
          <div className='h-10 w-32 animate-pulse rounded-md bg-muted'></div>
        </div>

        {/* Bottom Row: Bulk Actions - Placeholder */}
        <div className='flex items-center justify-between'>
          <div className='flex items-center gap-2'>
            <div className='h-6 w-6 animate-pulse rounded bg-muted'></div>
            <div className='h-4 w-32 animate-pulse rounded bg-muted'></div>
          </div>
          <div className='flex gap-2'>
            <div className='h-9 w-20 animate-pulse rounded-md bg-muted'></div>
            <div className='h-9 w-20 animate-pulse rounded-md bg-muted'></div>
          </div>
        </div>
      </div>

      {/* Loading Overlay */}
      <div className='relative mt-4 min-h-0 flex-1'>
        <div className='absolute inset-0 z-10 flex items-center justify-center bg-background/50 backdrop-blur-sm'>
          <div className='flex items-center gap-2 text-sm text-muted-foreground'>
            <Loader2 className='h-4 w-4 animate-spin' />
            <span>Loading followers...</span>
          </div>
        </div>

        {/* Placeholder content with reduced opacity */}
        <div className='pointer-events-none opacity-50'>
          <div className='pl-1 pr-4 pt-1'>
            <div className='grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4'>
              {Array.from({ length: 8 }).map((_, index) => (
                <div
                  key={index}
                  className='rounded-lg border bg-card p-4 shadow-sm'
                >
                  <div className='flex items-start gap-3'>
                    <div className='h-12 w-12 animate-pulse rounded-full bg-muted'></div>
                    <div className='flex-1 space-y-2'>
                      <div className='h-4 w-3/4 animate-pulse rounded bg-muted'></div>
                      <div className='h-3 w-1/2 animate-pulse rounded bg-muted'></div>
                      <div className='h-3 w-full animate-pulse rounded bg-muted'></div>
                    </div>
                  </div>
                  <div className='mt-3 flex gap-2'>
                    <div className='h-8 w-16 animate-pulse rounded bg-muted'></div>
                    <div className='h-8 w-16 animate-pulse rounded bg-muted'></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FollowerLoadingState;
